<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>INSPECTOR</h1>
    <app-help screen="inspector"></app-help>
  </div>
</div>

<app-publish [schoolId]="schoolId"></app-publish>

@if (cc.institutionalMethod$ | async) {
  <mat-card appearance="outlined" style="margin-bottom: 2rem">
    <mat-card-content>
      <p>Your NPC uses the IM options you’ve selected on the <a href="https://highered.collegeboard.org/need-analysis-options" target="_blank">Need Analysis Option site</a> to calculate contributions for your students and their families.</p>
    </mat-card-content>
  </mat-card>
}
@if (is.sessions | async; as sessions) {
  <div class="session-selector">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <h2>Select an NPC session to compare any rule changes</h2>
        </mat-card-title>
        <mat-card-subtitle>After affirming changes - publish the rules to your live Net Price Calculator.</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="session-field">
          <mat-label>Session</mat-label>
          <mat-select [(value)]="selected" (selectionChange)="cloudSessions($event)">
            <mat-option value="new"> Create new session... </mat-option>
            @for (session of sessions; track session) {
              <mat-option [value]="session"> [{{ session.savedAt.toDate() | date: "MM/dd/yy" }}] {{ session.sessionName }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (selected && selected !== 'new') {
          <a mat-flat-button color="primary" [href]="sessionPreviewHref()" target="_blank" (click)="openSessionPreview($event)">Go to session</a>
          <button mat-button color="warn" style="margin-left: 1rem" (click)="deleteSession(selected.id)">Delete session</button>
        }

        <!-- <button mat-button (click)="getCode(selected.answers)">get answers</button> -->
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <h2>Convert a student session</h2>
        </mat-card-title>
        <mat-card-subtitle>Paste a Guest Session share link or session ID to create a session to analyze</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <form class="convert-session-form" (ngSubmit)="createSession()">
          <mat-form-field class="student-session-field">
            <mat-label>Session ID or share link</mat-label>
            <input
              id="convert-session-input"
              matInput
              name="studentSessionInput"
              [(ngModel)]="studentSessionInput"
              placeholder="Paste a share link or session ID"
              autocomplete="off"
              aria-describedby="convert-session-hint"
            />
            <mat-hint id="convert-session-hint">Accepts a copied Guest Session URL or the session ID from that link.</mat-hint>
          </mat-form-field>
          <button
            mat-button
            color="primary"
            type="submit"
            [disabled]="!studentSessionInput.trim() || creatingSession"
          >
            Create session
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
}
@if (draftResults | async; as draftResult) {
  @if (baseResults | async; as publishedResult) {
    <mat-tab-group mat-stretch-tabs="false" dynamicHeight>
      <mat-tab label="Published vs. Draft">
        <ng-template matTabContent>
          <div class="tab-card-row">
            <mat-card class="data-card" appearance="outlined">
              <mat-card-header>
                <h2>Cost of Attendance</h2>
              </mat-card-header>
              <mat-card-content class="table-card">
                <table class="table" style="width: auto">
                  <thead>
                    <th scope="col">Type</th>
                    <th scope="col">Published<br />{{ (cc.publishedRules | async)?.schoolProperties?.aidYear }}</th>
                    <th scope="col">Draft<br />{{ (cc.draftRules | async)?.schoolProperties?.aidYear }}</th>
                    <th scope="col">Difference</th>
                  </thead>
                  <tbody>
                    @for (comp of costComparison | async; track comp.type) {
                      <tr [ngClass]="{ 'summary-row': comp.type === 'Total Cost' }">
                        <th scope="row" style="font-weight: normal">{{ comp.type }}</th>
                        <td>{{ comp.base | number }}</td>
                        <td>{{ comp.changed | number }}</td>
                        <td class="difference">{{ comp.diff > 0 ? "+" : "" }}{{ (comp.diff !== 0 ? comp.diff : "") | number }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </mat-card-content>
            </mat-card>
            <mat-card class="data-card" appearance="outlined">
              <mat-card-header>
                <h2>Aid & Self-Help</h2>
              </mat-card-header>
              <mat-card-content class="table-card">
                <table class="table" style="width: auto">
                  <thead>
                    <th scope="col">Type</th>
                    <th scope="col">Published</th>
                    <th scope="col">Draft</th>
                    <th scope="col">Difference</th>
                  </thead>
                  <tbody>
                    @for (comp of aidComparison | async; track comp.type) {
                      <tr [ngClass]="{ 'summary-row': comp.type === 'Total Grant Aid' || comp.type === 'Net Price' }">
                        @if (!(comp.base === 0 && comp.changed === 0)) {
                          <th scope="row" style="font-weight: normal">{{ comp.type }}</th>
                          <td>{{ comp.base | number }}</td>
                          <td>{{ comp.changed | number }}</td>
                          <td class="difference">{{ comp.diff > 0 ? "+" : "" }}{{ (comp.diff !== 0 ? comp.diff : "") | number }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Populations">
        <ng-template matTabContent>
          <div class="tab-card-row">
            <mat-card class="data-card" appearance="outlined">
              <mat-card-header>
                <h2>Populations</h2>
              </mat-card-header>
              <mat-card-content class="table-card">
                <table class="table" style="width: auto">
                  <thead>
                    <th scope="col">Type</th>
                    <th scope="col">Published</th>
                    <th scope="col">Draft</th>
                  </thead>
                  <tbody>
                    @for (popComp of popComparison | async; track popComp.id) {
                      <tr>
                        <th scope="row" style="font-weight: normal">{{ popComp.name }}</th>
                        <td>{{ popComp.base ? "yes" : "no" }}</td>
                        <td [ngClass]="{ difference: popComp.base !== popComp.changed }">{{ popComp.changed ? "yes" : "no" }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="Packaging">
        <ng-template matTabContent>
          <app-packaging-preview
            [published]="publishedResult.packagePreview"
            [draft]="draftResult.packagePreview"
          ></app-packaging-preview>
        </ng-template>
      </mat-tab>
      <mat-tab label="Need Analysis Results">
        <ng-template matTabContent>
          <app-inas-comparison [draft]="draftResult.cloudInasReponse" [published]="publishedResult.cloudInasReponse"></app-inas-comparison>
        </ng-template>
      </mat-tab>
      @if ((user | async)?.admin) {
        <mat-tab label="raw request">
          <ng-template matTabContent>
            <div class="tab-card-row raw-output">
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header>
                  <h2>Published INAS Request</h2>
                </mat-card-header>
                <mat-card-content>
                  <pre>{{ publishedResult.cloudInasRequest | json }}</pre>
                </mat-card-content>
              </mat-card>
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header>
                  <h2>Draft INAS Request</h2>
                </mat-card-header>
                <mat-card-content>
                  <pre>{{ draftResult.cloudInasRequest | json }}</pre>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="raw response">
          <ng-template matTabContent>
            <div class="tab-card-row raw-output">
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header>
                  <h2>Published INAS Response</h2>
                </mat-card-header>
                <mat-card-content>
                  <pre>{{ publishedResult.cloudInasReponse | json }}</pre>
                </mat-card-content>
              </mat-card>
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header>
                  <h2>Draft INAS Response</h2>
                </mat-card-header>
                <mat-card-content>
                  <pre>{{ draftResult.cloudInasReponse | json }}</pre>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  } @else {
    {{ selected ? "Waiting on results from NPC Calculation Engine..." : "" }}
  }
} @else {
  {{ selected ? "Waiting on results from NPC Calculation Engine..." : "" }}
}
